export enum BILLING_CYCLES {
    ONE_TIME = 'one_time',
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly',
    SEMIANNUALLY = 'semiannually',
    YEARLY = 'yearly',
}

export enum BILLING_TIME {
    ANNIVERSARY = 'anniversary',
    REGULAR = 'regular',
    CUSTOM = 'custom',
}

export enum MEASUREMENT_TYPE {
    STATEFUL = 'stateful',
    METERED = 'metered',
}

export enum STATEFUL_BILLING_STRATEGY {
    TIME_WEIGHTED = 'time_weighted',
    END_OF_PERIOD = 'end_of_period',
    MAX_IN_PERIOD = 'max_in_period',
}

export enum METERED_BILLING_STRATEGY {
    SUM = 'sum',
    MAX = 'max',
    LAST = 'last',
}

export enum BILLING_STATUS {
    PAST = 'past',
    CURRENT = 'current',
    SCHEDULED = 'scheduled',
}

export type ServicePlanBillingPolicy= {
    id: string;
    created_at: string;
    modified_at: string;
    version_number: number;
    status: BILLING_STATUS;
    valid_from: string;
    billing_cycle: BILLING_CYCLES;
    billing_time: BILLING_TIME;
    measurement_type: MEASUREMENT_TYPE;
    valid_to: string | null;
    stateful_billing_strategy: STATEFUL_BILLING_STRATEGY;
    metered_billing_strategy: METERED_BILLING_STRATEGY;
    enable_proration: boolean | null;
}